import { getPaddingString, formFieldErrorHtml } from "../parser/utils";

export default ({ data, id }) => {
  const { label, desc, content, termsType, freeText, } = data;
  if (termsType === "free") {
    return `
      <div class="rip-field-group" style="${getPaddingString(data)}">
        <div
          style="
            height: 35px;
            display: flex;
            align-items: center;
            gap: 8px;
          "
        >
          <input style="width: 16px; height: 16px; border: 1px solid #cccccc;" type="checkbox" name="${id}" value="True" />
          <div>${freeText}</div>
        </div>
        ${formFieldErrorHtml({ id })}
      </div>
    `;
  }
  return `
    <div class="rip-field-group" style="${getPaddingString(data)}">
      <div
        style="
          height: 35px;
          display: flex;
          align-items: center;
          gap: 8px;
        "
      >
        <input style="width: 16px; height: 16px; border: 1px solid #cccccc;" type="checkbox" name="${id}" value="True" />
        <div style="cursor: pointer;" class="${id}-terms-content_open">${desc}</div>
        <div id="${id}-terms-content" style="display: none; padding: 15px; background: white; max-width: 500px; width: calc(100% - 20px);border-radius: 5px">
          <button class="${id}-terms-content_close" style="position: absolute;top: 0;right: 0;background: none;border: none;width: 32px;font-size: 30px;cursor: pointer;">×</button>
          <label>${label}</label>
          <div>${content}</div>
        </div>
      </div>
      ${formFieldErrorHtml({ id })}
      <script>
        $("#${id}-terms-content").popup({
          transition: 'all 0.3s',
        });
      </script>
    </div>
  `;
};
